import { AdPlacement } from '@tajawal/web-core-sdk-v2/lib/types/ad-solution.types';
import { AD_INTERACTION } from '@tajawal/web-core-sdk-v2/lib/constants/ad-solution.constants';
import { FILTER_PARAM_MAP } from '@tajawal/web-flights-sdk/lib/constants/filters.constants';
import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';
import { useStore } from '@/contexts/StoreContext';
import { useQuery } from './useQuery';
import { pushAdAvailableEvent, pushAdClickedEvent, pushAdDisplayedEvent } from '@/utils/avoGtm.utils';
import { useEffect } from 'react';
import _each from 'lodash/forEach';

function useAdBanner(shouldFireEvents = true) {
  const store = useStore();
  const { isRoundTrip } = useQuery();

  const state = useMapStoreStateToClientState(store, (store) => {
    const pageStore = isRoundTrip ? store.appStore.stepByStepSearchPage.outbound : store.appStore.completeSearchPage;
    return {
      adBanners: pageStore.adSolution.adBannerMap,
      setAppliedBanner: pageStore.adSolution.setAppliedBanner,
      sendInteraction: pageStore.adSolution.sendInteraction,
      airlineFilter: pageStore.filters.airline,
      adPlacements: pageStore.adSolution.adPlacements,
      isAdPlacementsFetched: pageStore.adSolution.isAdPlacementsFetched,
    };
  });

  useEffect(() => {
    if (state.isAdPlacementsFetched && shouldFireEvents) {
      _each(state.adPlacements, (adBanner: AdPlacement) => {
        pushAdAvailableEvent(adBanner);
      });
    }
  }, [state.isAdPlacementsFetched]);

  const handleAdClick = (adBanner: AdPlacement) => {
    pushAdClickedEvent(adBanner);
    if (!adBanner.filters) return;
    state.setAppliedBanner(adBanner.zoneId);
    const queryParams = new URLSearchParams(adBanner.filters);
    state.airlineFilter.toggle([queryParams.get(FILTER_PARAM_MAP.airline)], true);
    state.sendInteraction(adBanner.zoneId, AD_INTERACTION.REDIRECT);
  };

  const handleAdLoaded = (adBanner: AdPlacement) => {
    state.sendInteraction(adBanner.zoneId, AD_INTERACTION.ELIGIBLE);
    pushAdDisplayedEvent(adBanner);
  };

  const handleAdViewed = (adBanner: AdPlacement) => {
    state.sendInteraction(adBanner.zoneId, AD_INTERACTION.VIEWABLE);
  };

  return {
    ...state,
    handleAdClick,
    handleAdLoaded,
    handleAdViewed,
    isValidToShowAdBanner: !state.airlineFilter.isTouched,
  };
}

export default useAdBanner;
